export default __webpack_public_path__ + "static/img2_name_type_instru-0432ced6bab4a1d154c9d51d23c345cc.png";